import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import CreditOutlet from "../../../components/leave/credits/CreditOutlet";

const DepartmentalLeaveCredits = () => {
    const location = useLocation();
    const segments = location.pathname.split('/').filter(Boolean);
    const queryParams = new URLSearchParams(location.search);
    
    const department = queryParams.get('label');
    const departmentslug = segments?.[2];

    return (
        <div className="leave-credits">
            <div className="page-header">
                <div className="title">
                    <h1>Leave Credits</h1>
                    <ul className="breadcrumbs">
                        <li>
                            <NavLink to='/leaves/my-leave'>Leave</NavLink>
                        </li>
                        <li>
                            <NavLink to="/leaves/credits">Credits</NavLink>
                        </li>
                        <li>
                            <span>{department}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <CreditOutlet departmentslug={departmentslug} />
        </div>
    )
}

export default DepartmentalLeaveCredits;